(function (global) {
  'use strict';

  let lightboxCurrentIndex = -1;
  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.GalleryOnPage = global.NewHomeSource.GalleryOnPage || {};
  global.NewHomeSource.GalleryOnPage.PlanTracking = global.NewHomeSource.GalleryOnPage.PlanTracking || {};

  class SegmentEvents {
    /**
     * Handles carousel navigation events and dispatches a Segment event.
     */
    static carouselNavigationSegmentEvent() {
      const eventSegment = {
        event: 'Home Image Displayed',
        media_type: 'Plan',
        type: 'Listings',
        eventType: 'segmentEvent',
      };

      document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
        detail: { data: eventSegment }
      }));
    }

    /**
     * Handles lightbox element change events and dispatches a Segment event.
     *
     * @param {Object} detail - The detail object from the event.
     */
    static lightboxElementChangeSegmentEvent(detail) {
      if (lightboxCurrentIndex !== detail.index) {
        lightboxCurrentIndex = detail.index;
        // Only dispatch event for images (Home Video Played event is tracked via video interaction event)
        if (!detail.isVideo) {
          const typeMap = {
            FloorPlan: {
              event: 'Floorplan Displayed',
              floorplan_sequence: detail.index + 1,
              floorplan_type: 'FLP',
              floorplan_url: detail.url,
              eventType: 'segmentEvent',
            },
            ExternalMedium: {
              event: '3D tour Displayed',
              tour_sequence: detail.index + 1,
              tour_id: detail.id,
              eventType: 'segmentEvent',
            },
          };

          const eventSegment = typeMap[detail.type] || {
            event: 'Home Image Displayed',
            media_type: detail.type,
            image_sequence: detail.index + 1,
            image_type: detail.type,
            image_url: detail.url,
            eventType: 'segmentEvent',
          };

          document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
            detail: { data: eventSegment }
          }));
        }
      }
    }

    /**
     * Resets the current index of the lightbox.
     */
    static resetLightboxCurrentIndex() {
      lightboxCurrentIndex = -1;
    }

    /**
     * Handles media click events and dispatches a Segment event.
     */
    static mediaClickSegmentEvent() {
      const eventSegment = {
        event: 'Gallery Viewer Opened',
        media_type: 'Plan',
        type: 'Listings',
        eventType: 'segmentEvent',
      };

      document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
        detail: { data: eventSegment }
      }));
    }

    /**
     * Handles video interaction events and dispatches a Segment event.
     *
     * @param {Object} detail - The detail object from the event.
     */
    static videoInteractionSegmentEvent(detail) {
      if (detail.interaction === 'video_play') {
        const eventSegment = {
          event: 'Home Video Played',
          media_type: 'Video',
          image_sequence: lightboxCurrentIndex + 1,
          eventType: 'segmentEvent',
        };

        const currentElement = document.querySelector(`[data-column="${lightboxCurrentIndex}"]`);
        if (currentElement) {
          eventSegment.image_type = currentElement.dataset.type;
          eventSegment.image_url = currentElement.dataset.url;
        }

        document.body.dispatchEvent(new CustomEvent('trackOnDemandEvent', {
          detail: { data: eventSegment }
        }));
      }
    }
  }

  global.NewHomeSource.GalleryOnPage.PlanTracking.SegmentEvents = SegmentEvents;
}(window));
